// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1FSoj","productName":"Table_productName__2sLBU"};